import {
  Dialog,
  type DialogProps,
  Button,
  Icon,
  Text,
  Flex,
  Spacer,
} from '@backyard-ui/core';
import { LocationOutline } from '@backyard-ui/icons';

interface RecontextAlertDialogProps
  extends Pick<DialogProps, 'isOpen' | 'onOpenChange'> {
  onCancel: () => void;
  onConfirm: () => void;
}

export default function RecontextAlertDialog(
  props: Readonly<RecontextAlertDialogProps>
) {
  const { isOpen, onOpenChange, onCancel, onConfirm } = props;

  return (
    <Dialog.Root
      size="sm"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isCentered
      closeOnOverlayClick={false}
    >
      <Dialog.Content>
        <Dialog.CloseButton data-testid="cancel-button" onClick={onCancel} />
        <Dialog.Title>
          <Flex align="baseline">
            <Text color="green-700">
              <Icon size="lg">
                <LocationOutline />
              </Icon>
            </Text>
            <Spacer size="2" />
            Ao atualizar a região
          </Flex>
        </Dialog.Title>
        <Dialog.Description>
          Informações, valores e itens disponíveis podem sofrer alterações.
        </Dialog.Description>

        <Dialog.Footer>
          <Dialog.Close>
            <Button onClick={onConfirm}>Atualizar</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}
